import { Fragment } from "react";

interface HighlightedTextProps {
  text: string;
  selectedText: string;
}

export const HighlightedText = ({
  text,
  selectedText,
}: HighlightedTextProps) => {
  if (
    !selectedText ||
    !text?.toLowerCase().includes(selectedText.toLowerCase())
  ) {
    return <span>{text}</span>;
  }

  // Create a case-insensitive regex to split the text
  const regex = new RegExp(
    `(${selectedText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
    "gi",
  );
  const parts = text.split(regex);

  return (
    <span>
      {parts.map((part, index) => {
        // Check if this part matches the selected text (case-insensitive)
        const isMatch = part.toLowerCase() === selectedText.toLowerCase();

        return (
          <Fragment key={index}>
            {isMatch ? (
              <span className="bg-yellow-300 font-medium" data-highlight="true">
                {part}
              </span>
            ) : (
              part
            )}
          </Fragment>
        );
      })}
    </span>
  );
};
